import React from 'react';
import PolicyEmbed from '../components/PolicyEmbed';

const PrivacyPolicy = () => {
  return (
    <PolicyEmbed 
      id="ZVRCTk1reFRiV3BwVVRSUWNHYzlQUT09" 
      title="Privacy Policy" 
    />
  );
};

export default PrivacyPolicy;
